<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="立项编号">
              <a-input v-model="query.establishmentNo" placeholder="请输入立项编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="立项人">
              <a-input v-model="query.executeUserName" placeholder="请输入立项人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12" style="margin-left: 10px">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="立项内容">
              <a-input v-model="query.content" placeholder="请输入立项内容" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始时间">
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                show-time
                placeholder="选择开始时间"
                @change="changes"
                v-model="startTime"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结束时间">
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                show-time
                placeholder="选择结束时间"
                @change="changet"
                v-model="endTime"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12" style="display: flex">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <!-- <a-button type="primary" style="margin-left: 12px" @click="approval(id)">审批</a-button> -->
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdate()" v-action:lxadd>新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:lxdel
                >删除</a-button
              >
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      size="middle"
      rowKey="id"
      bordered
      :scroll="{ x: 2100 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="dataUrl" slot-scope="text, record">
        <span>{{ record.dataUrl[0].name }}</span>
      </span>
      <span slot="approveStatus" slot-scope="text, record">
        <a-tag v-if="record.approveStatus === 0" color="rgb(255, 99, 71)">审批中</a-tag>
        <a-tag v-if="record.approveStatus === 1" color="rgb(50, 205, 50)">已审批</a-tag>
        <a-tag v-if="record.approveStatus === 2" color="rgb(255, 99, 71)">审批不通过</a-tag>
      </span>
      <!-- <div slot="action" slot-scope="text, record" style="width: 110px; display: flex; justify-content: space-between">
        <a-button size="small" type="primary" style="font-size: 12px" @click="addOrUpdateHandle(record.id)">
          编辑
        </a-button>
      </div> -->
    </a-table>
    <!-- 新增 修改 -->
    <a-modal
      :title="titieh"
      style="top: 20px"
      :width="800"
      :visible="addOrUpdateVisible"
      :destroyOnClose="true"
      @ok="handleOkaddOrUpdate"
      @cancel="handleCancelh"
    >
      <a-form-model class="tenant-form" :model="engineeringProjectEstab" ref="engineeringProjectEstab" :rules="rules">
        <a-form-model-item
          :label="titieh + '编号'"
          prop="establishmentNo"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input disabled v-model="engineeringProjectEstab.establishmentNo" placeholder="系统自动按规则生成" />
        </a-form-model-item>
        <a-form-model-item label="项目名称" prop="establishmentName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.establishmentName" />
        </a-form-model-item>
        <a-form-model-item :label="titieh + '内容'" prop="content" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.content" />
        </a-form-model-item>

        <a-form-model-item
          :label="titieh + '类型'"
          prop="establishmentType"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select v-model="engineeringProjectEstab.establishmentType">
            <a-select-option v-for="item in AppliCAtion" :key="item.dictValue">{{ item.dictValue }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item label="立项人" prop="establishmentUserId" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.establishmentUserId" />
        </a-form-model-item> -->
        <!-- <a-form-model-item label="创建人" prop="createName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.createName" />
        </a-form-model-item> -->
        <a-form-model-item label="执行人" prop="executeUserId" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select placeholder="选择一个执行人" v-model="engineeringProjectEstab.executeUserId">
            <a-select-option v-for="item in userlist" :key="item.key.principalId" :value="item.key.principalId">
              {{ item.key.principal }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="phone" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.phone" />
        </a-form-model-item>
        <a-form-model-item label="地址" prop="address" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.address" />
        </a-form-model-item>
        <!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划开始时间" prop="startTime">
          <a-date-picker
            format="YYYY-MM-DD HH:mm:ss"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :showTime="true"
            v-model="engineeringProjectEstab.startTime"
            @change="onChange"
          />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划结束时间" prop="endTime">
          <a-date-picker
            format="YYYY-MM-DD HH:mm:ss"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :showTime="true"
            v-model="engineeringProjectEstab.endTime"
            @change="onChange"
          />
        </a-form-model-item> -->
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划开始时间" prop="startValue">
          <a-date-picker
            v-model="engineeringProjectEstab.startValue"
            :disabled-date="disabledStartDate"
            show-time
            @change="onChangeh"
            format="YYYY-MM-DD HH:mm:ss"
            @openChange="handleStartOpenChange"
          />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划结束时间" prop="endValue">
          <a-date-picker
            v-model="engineeringProjectEstab.endValue"
            :disabled-date="disabledEndDate"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            :open="endOpen"
            @change="onChanget"
            @openChange="handleEndOpenChange"
          />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="审批状态">
          <a-input placeholder="通过审批按钮自动生成" disabled style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
          <a-textarea v-model="engineeringProjectEstab.remark" :rows="4" style="width: 690px" />
        </a-form-model-item>
        <a-form-model-item label="附件上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-upload-dragger name="file" :multiple="true" :customRequest="customRequest" :showUploadList="false">
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              文件拖拽此处或
              <a>点击上传</a>
            </p>
          </a-upload-dragger>
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in engineeringProjectEstab.fileNames" :key="item.url">
                <div class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </div>
                <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" />
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      visible: false,
      queryUrl: '/pipe-network/engineering_project_establishments/page', //列表请求数据接口
      queryOneUrl: '/pipe-network/engineering_project_establishments/', //查询单条地址
      deleteUrl: '/pipe-network/engineering_project_establishments', //删除
      uploadUrl: 'manager/file/resources/upload', // 上传文件URL
      staffTreeData: [], // 分区数据选项
      bookTreeData: [], // 分区数据选项
      userlist: [],
      currId: 0,
      AppliCAtion: [],
      shows: false,
      showst: false,
      endOpen: false,
      titieh: '立项',
      startTime: '',
      endTime: '',
      query: {
        establishmentNo: '',
        establishmentType: '',
        executeUserName: '',
        approveStatus: '',
        content: '',
        createTime: '',
        startTime: '',
        endTime: '',
      }, // 查询参数
      addOrUpdateVisible: false, // 新增修改是否可见
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      engineeringProjectEstab: {
        projectType: '立项', //项目类型
        establishmentNo: '', //项目编码
        establishmentName: '', //项目名称
        content: '', //内容
        establishmentType: '', //立项类型
        establishmentUserName: '', //申请人
        executeUserId: '', //	执行人
        phone: '', //联系方式
        address: '', //地址
        createTime: '', //时间
        startTime: '', //计划开始时间
        endTime: '', //计划结束时间
        remark: '', //备注
        fileNames: [], //上传资料
        startValue: null,
        endValue: null,
        createName: '',
      },
      rules: {
        establishmentName: [{ required: true, message: '请输入项目名称', trigger: 'change' }],
        content: [{ required: true, message: '请输入内容', trigger: 'change' }],
        establishmentType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        // establishmentUserId: [{ required: true, message: '请输入立项人', trigger: 'change' }],
        // createName: [{ required: true, message: '请输入创建人', trigger: 'change' }],
        executeUserId: [{ required: true, message: '请选择执行人', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择计划结束时间', trigger: 'change' }],
        address: [{ required: true, message: '请输入地址', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'change' },
          { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确联系方式', trigger: 'change' },
        ],
      },
      columns: [
        {
          title: '立项编号',
          dataIndex: 'establishmentNo',
        },
        {
          title: '立项名称',
          dataIndex: 'establishmentName',
          ellipsis: true,
        },
        {
          title: '立项人',
          dataIndex: 'establishmentUserName',
        },
        {
          title: '联系方式',
          dataIndex: 'phone',
        },
        {
          title: '地址',
          dataIndex: 'address',
          ellipsis: true,
        },
        {
          title: '立项时间',
          dataIndex: 'createTime',
        },
        {
          title: '内容',
          dataIndex: 'content',
          ellipsis: true,
        },
        {
          title: '立项类型',
          dataIndex: 'establishmentType',
        },
        {
          title: '创建人',
          dataIndex: 'createName',
        },
        // {
        //   title: '操作',
        //   align: 'center',
        //   key: 'operation',
        //   fixed: 'right',
        //   width: 100,
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
    }
  },
  created() {
    this.queryList()
    this.Responsibleinterface()
    this.getTaskList()
    this.currentUser()
  },
  methods: {
    resetList() {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.startTime = ''
      this.endTime = ''
      this.queryList()
    },
    changes(a, i) {
      if (i == '') {
        this.query.startTime = i
      } else {
        this.query.startTime = i + ' 00:00:00'
      }
    },
    changet(a, i) {
      if (i == '') {
        this.query.endTime = i
      } else {
        this.query.endTime = i + ' 00:00:00'
      }
    },
    currentUser() {
      this.engineeringProjectEstab.createName = this.$store.getters.userInfo.nickName
      this.engineeringProjectEstab.establishmentUserId = this.$store.getters.userInfo.nickName
    },
    //时间
    disabledStartDate(startValue) {
      const endValue = this.engineeringProjectEstab.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = this.engineeringProjectEstab.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    onChangeh(date, dateString) {
      this.engineeringProjectEstab.startTime = dateString
    },
    onChanget(date, dateString) {
      this.engineeringProjectEstab.endTime = dateString
    },
    //负责人下拉框
    Responsibleinterface() {
      this.$http.get('/pipe-network/engineering_project_establishments/principals').then(({ data }) => {
        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.real_name,
            key: item,
            name: item.real_name,
          })
        })
        this.userlist = list
      })
    },
    //字典
    getTaskList() {
      const params = {
        dictCode: 'APPLICATION-TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        
        this.AppliCAtion = data
        console.log(data, '字典')
      })
    },
    //新增更新
    addOrUpdate() {
      console.log(this.engineeringProjectEstab.fileNames.splice(0, this.engineeringProjectEstab.fileNames.length))
      this.addOrUpdateVisible = true
    },
    handleOkaddOrUpdate() {
      this.$refs.engineeringProjectEstab.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](
            '/pipe-network/engineering_project_establishments',
            this.query.sysType
              ? { id: this.currentId, sysType: this.query.sysType, ...this.engineeringProjectEstab }
              : { id: this.currentId, ...this.engineeringProjectEstab }
          ).then((res) => {
            if (res.code == 0) {
              this.addOrUpdateVisible = false
              this.queryList()
              this.engineeringProjectEstab.fileNames = []
              return this.$message.success(res.message)
            } else {
              this.addOrUpdateVisible = false
              return this.$message.warn(res.message)
            }
          })
          this.$refs.engineeringProjectEstab.resetFields()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleCancelh() {
      this.addOrUpdateVisible = false
      this.engineeringProjectEstab.fileNames = []
      this.$refs.engineeringProjectEstab.resetFields()
    },
    //取消
    handleCancel() {
      this.visible = false
    },
    // 根据id 修改
    addOrUpdateHandle(id) {
      this.isUpdate = false
      this.addOrUpdateVisible = true
      this.currentId = id
      this.RightData = []
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.engineeringProjectEstab = {
              projectType: this.titieh, //项目类型
              establishmentNo: data.establishmentNo, //项目编码
              establishmentName: data.establishmentName, //项目名称
              content: data.content, //内容
              establishmentType: data.establishmentType, //立项类型
              establishmentUserId: data.establishmentUserId, //申请人
              phone: data.phone, //联系方式
              address: data.address, //地址
              createTime: data.createTime, //时间
              startTime: data.startTime, //计划开始时间
              endTime: data.endTime, //计划结束时间
              remark: data.remark, //备注
              fileNames: data.fileNames,
              createName: data.createName,
            }
          })
          .catch(() => {})
      }
    },
    onChange(date, dateString) {
      console.log(date, dateString)
    },
    customRequest(data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            let obj = {
              url: response.data.url,
              name: response.data.fileName,
            }
            this.engineeringProjectEstab.fileNames.push(obj)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    uploadFile(item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile(url) {
      let index = this.engineeringProjectEstab.fileNames.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.engineeringProjectEstab.fileNames.splice(index, 1)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
